<template>
  <div class="toast-host">
    <transition-group name="toast">
      <div v-for="t in toasts" :key="t.id" class="toast" :class="t.type" @click="dismiss(t.id)">
        <i class="fas" :class="icon(t.type)"></i>
        <span>{{ t.message }}</span>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useToastStore } from '@/stores/toast';

export default {
  name: 'ToastHost',
  computed: { ...mapState(useToastStore, ['toasts']) },
  methods: {
    ...mapActions(useToastStore, ['dismiss']),
    icon(t) {
      return { success: 'fa-circle-check', error: 'fa-circle-exclamation', info: 'fa-circle-info' }[t] || 'fa-circle-info';
    },
  },
};
</script>

<style scoped>
.toast-host { position: fixed; top: 16px; right: 16px; z-index: 99999; display: flex; flex-direction: column; gap: 8px; max-width: 92vw; }
.toast { display: flex; align-items: center; gap: 9px; background: #fff; border: 1px solid #e2e5dd; border-left-width: 4px; border-radius: 10px; padding: 11px 14px; font-size: 13px; box-shadow: 0 8px 24px rgba(20,30,15,.14); cursor: pointer; min-width: 240px; color: #2c322b; }
.toast.success { border-left-color: #446936; } .toast.success i { color: #446936; }
.toast.error { border-left-color: #c0392b; } .toast.error i { color: #c0392b; }
.toast.info { border-left-color: #2d6cb5; } .toast.info i { color: #2d6cb5; }
.toast span { line-height: 1.35; }
.toast-enter-active, .toast-leave-active { transition: all .25s ease; }
.toast-enter-from { opacity: 0; transform: translateX(20px); }
.toast-leave-to { opacity: 0; transform: translateX(20px); }
@media (max-width: 520px) { .toast-host { top: auto; bottom: 16px; left: 12px; right: 12px; } .toast { min-width: 0; } }
</style>
